import Loading from '@/commons/components/Loading';
import useAuth from '@/hooks/useAuth';
import { RootState } from '@/redux/store';
import AppRouter from '@/routers/routes';
import { Layout } from 'antd';
import cx from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import CopyRight from '../CopyRight';
import MenuLeft from '../MenuLeft';
import TopMenu from '../TopMenu/TopMenu';

import './styles.scss';

const Admin: React.FC = () => {
  const { user } = useAuth();
  const menuCollapsed = useSelector<RootState, boolean>(
    (state: any) => state.app?.layoutState.menuCollapsed
  );
  return user ? (
    <Layout className="cbra-admin-layout">
      <MenuLeft />
      <div
        id="content-wrapper"
        className={cx('d-flex flex-column cbra-admin-layout__content-wrapper', {
          'cbra-admin-layout__content-wrapper--collapsed': menuCollapsed,
        })}
      >
        <TopMenu />
        <div id="content">
          <Layout className="cbra-admin-layout__main-layout position-relative h-100">
            <Layout.Content className="main-layout__content">
              <AppRouter />
            </Layout.Content>
            <CopyRight />
          </Layout>
        </div>
      </div>
    </Layout>
  ) : (
    <Loading />
  );
};

export default React.memo(Admin);
